import React from 'react';
import './input.css'


const Input = (props) => {
    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt'>{props.title}</label>
            <input className='inputt' type={props.type} 
            placeholder={props.placeholder}
            onChange={props.onChange}
            value={props.value}/>
        </fieldset>
     );
}
 
export default Input;